import { Marker, useMap, useMapEvents } from 'react-leaflet';
import { useCallback, useEffect, useState, useMemo, useRef } from 'react';
import { Rectangle, FeatureGroup } from 'react-leaflet';
import L, { DomEvent } from 'leaflet';
import 'leaflet-geometryutil';
import html2canvas from "html2canvas";
import { createPortal } from 'react-dom';
import '../../styles/PrintControl.css'
import { useDispatch, useSelector } from 'react-redux';
import drawLocales from 'leaflet-draw-locales'
import '../../icons/Roboto-Light-bold.js';
import '../../icons/Roboto-Light-normal.js';
import '../../icons/Roboto-Medium-normal.js'
import { Verified } from '@mui/icons-material';
import { Tooltip, Button, Typography, Box } from '@mui/material';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import { setModal } from '../../store/reducers/helpersReducer.js';
import { $authHost } from '../../http/index.js';
// import * as turf from '@turf/turf';
// Automatically defines Leaflet.draw to the specified language
drawLocales('ru')


const MM_TO_METERS = 0.001;
const MM_TO_INCH = 1 / 25.4;

const getPaperDimensions = (format, orientation) => {
    const formatMatch = format.toLowerCase().match(/(a|b)(\d)/i);
    if (!formatMatch) throw new Error('Invalid paper format');


    const [, series, size] = formatMatch;
    const n = parseInt(size, 10);

    let baseWidth, baseHeight;
    if (series === 'a') {
        baseWidth = 841;   // A0 width in mm
        baseHeight = 1189; // A0 height in mm
    } else {
        baseWidth = 1000;  // B0 width in mm
        baseHeight = 1414; // B0 height in mm
    }

    const divisor = 2 ** (n / 2);
    const width = Math.floor(baseWidth / divisor);
    const height = Math.floor(baseHeight / divisor);
    return orientation === 'landscape'
        ? { width: height, height: width }
        : { width, height };
};



const ExecutionControl = () => {
    const map = useMap();
    const dispatch = useDispatch();
    const [hide, setHide] = useState(false);
    const [verified, setVerified] = useState(false);
    const stageFilter = useSelector(state => state.state.filter?.stage)
    const [polygon, setPolygon] = useState(null)
    const [isDrawing, setIsDrawing] = useState(false)
    
    const polygonRef = useRef(null)
    const drawingRef = useRef(null)
    const isDrawingRef = useRef(false)
    // const mountedRef = useRef(null)

    // Функция для точной проверки нахождения точки внутри полигона (с использованием Turf.js)
    // const isPointInPolygon = (latlng, polygonLayer) => {
    //     if (!polygonLayer) return false;

    //     // Получаем координаты полигона
    //     const latLngs = polygonLayer.getLatLngs()[0]; // Берем первый кольцо (внешний контур)

    //     // Преобразуем в формат GeoJSON для Turf.js
    //     const coordinates = latLngs.map(ll => [ll.lng, ll.lat]);
    //     coordinates.push(coordinates[0]); // Замыкаем полигон

    //     const polygon = turf.polygon([coordinates]);
    //     const point = turf.point([latlng.lng, latlng.lat]);

    //     return turf.booleanPointInPolygon(point, polygon);
    // };

    // Альтернативная функция без внешних библиотек (алгоритм Ray Casting)
    const isPointInPolygonRayCasting = (latlng, polygonLayer) => {
        if (!polygonLayer) return false;

        const latLngs = polygonLayer.getLatLngs()[0];
        const x = latlng.lat;
        const y = latlng.lng;

        let inside = false;
        for (let i = 0, j = latLngs.length - 1; i < latLngs.length; j = i++) {
            const xi = latLngs[i].lat;
            const yi = latLngs[i].lng;
            const xj = latLngs[j].lat;
            const yj = latLngs[j].lng;

            if (((yi > y) !== (yj > y)) && (x < (xj - xi) * (y - yi) / (yj - yi) + xi)) {
                inside = !inside;
            }
        }

        return inside;
    };

    // Инициализация обработчика рисования
    useEffect(() => {
        // let pane = map.getPane('drawingPane')
        // if (!pane) {
        //     pane = map.createPane('drawingPane')
        //     pane.style.zIndex = 700
        //     pane.style.pointerEvents = 'all'
        // }
        // , { shapeOptions: {pane: 'drawingPane'}}
        if (map && !drawingRef.current) {
            drawingRef.current = new L.Draw.Polygon(map, { shapeOptions: { pane: 'drawingPane' } });
        }
        console.log('Draw handler initialized');

        // Подписываемся на событие создания полигона
        const onDrawCreated = (e) => {
            
            console.log('draw:created event fired:', e);
            console.log('isDrawing state:', isDrawing);
            if (!isDrawingRef.current) return
            polygonRef.current = e.layer;
            map.addLayer(polygonRef.current);
            polygonRef.current.editing.enable();

            setPolygon(e.layer);
            // setIsDrawing(false); // Выключаем режим рисования после создания
        };

        const onSignalDrawing = (e) => {
            console.log(e)
            if (e.source !== 'execution') {
                setHide(e.state)
            }
        };

        // Пробуем оба варианта подписки
        map.on('draw:created', onDrawCreated);
        map.on(L.Draw.Event.CREATED, onDrawCreated);
        map.on('signal:drawing', onSignalDrawing);

        return () => {
            console.log('Cleaning up draw handler');
            map.off('draw:created', onDrawCreated);
            map.off(L.Draw.Event.CREATED, onDrawCreated);
            map.off('signal:drawing', onSignalDrawing);
        };
    }, [map]);

    useEffect(() => {
        if (isDrawing) {
            isDrawingRef.current = true
            drawingRef.current.enable()
            // fetchMounted()
            map.fire('signal:drawing', { source: 'execution', state: true })
        } else {
            isDrawingRef.current = false
            drawingRef.current.disable()
            map.fire('signal:drawing', { source: 'execution', state: false })
        }
    }, [isDrawing, map])


    // const fetchMounted = useCallback(() => {
    //     try {
    //         $authHost.get('/apig/execution/latest').then(res => {
    //             const { data } = res
    //             mountedRef.current = data.data;
    //         }).catch(err => {
    //             mountedRef.current = null;
    //         })
    //     } catch (err) {
    //         mountedRef.current = null;
    //     }
    // }, [])


    if (hide || !stageFilter || [1, 2].some(s => stageFilter.includes(s)) || stageFilter.length > 1) {
        return null
    }




    // Отрисовка сетки
    return createPortal(
        <Box sx={{ zIndex: 1202, display: 'flex', order: 3, pointerEvents: 'auto', width: 'fit-content' }}>
            <Box
                sx={{
                    // zIndex: 1202,
                    display: 'flex',
                    flexDirection: 'column',
                    boxShadow: '0px 2px 6px grey',
                    pointerEvents: 'auto',
                    backgroundColor: 'rgb(40, 40, 40)',
                    opacity: '0.9',
                    borderRadius: '5px',
                    // padding: '5px',

                }}
            >
                {!isDrawing &&
                    <Tooltip title={'Подтвердить выполнение'} placement='right'>
                        <Box sx={{
                            width: window.innerWidth < 768 ? 26 : 30,
                            height: window.innerWidth < 768 ? 26 : 30,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            transition: 'transform 0.3s ease-in-out',
                            '&:hover': {
                                transform: 'scale(1.1)',
                            }

                        }}
                            onClick={(e) => {
                                e.stopPropagation();
                                setIsDrawing(true)
                                setVerified(true)
                                // setTimeout(() => {
                                //     drawingRef.current.enable()
                                // }, 100)
                            }}

                        >

                            <Verified sx={{ fontSize: window.innerWidth < 768 ? 20 : 24, color: '#78A75A' }} />
                        </Box>

                    </Tooltip>}
                {!isDrawing &&
                    <Tooltip title={'Отменить выполнение'} placement='right'>
                        <Box sx={{
                            width: window.innerWidth < 768 ? 26 : 30,
                            height: window.innerWidth < 768 ? 26 : 30,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            transition: 'transform 0.3s ease-in-out',
                            '&:hover': {
                                transform: 'scale(1.1)',
                            }

                        }}
                            onClick={(e) => {
                                e.stopPropagation();
                                setIsDrawing(true)
                                setVerified(false)
                                // setTimeout(() => {
                                //     drawingRef.current.enable()
                                // }, 100)
                            }}

                        >

                            <span className="material-symbols-outlined" style={{ color: '#EA3323', fontSize: window.innerWidth < 768 ? 20 : 24 }}>
                                verified_off
                            </span>

                        </Box>
                    </Tooltip>}
                {/* {polygon &&
                                    <Tooltip title={isEditing ? 'Сохранить' : 'Редактировать'} placement='right'>
                                        <Box sx={{
                                            height: '30px',
                                            width: '30px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            cursor: 'pointer',
                                            color: isEditing ? 'rgb(60, 255, 0)' : 'rgb(0, 174, 255)',
                                            transition: 'transform 0.3s ease-in-out',
                                            '&:hover': {
                                                transform: 'scale(1.1)',
                                            }

                                        }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                if (!isEditing) {
                                                    polygonRef.current.editing.enable()
                                                    setIsEditing(true)
                                                } else {
                                                    polygonRef.current.editing.disable()
                                                    setIsEditing(false)
                                                }
                                            }}

                                        >
                                            {isEditing ? <SaveOutlinedIcon sx={{ fontSize: 24 }} /> : <EditOutlinedIcon sx={{ fontSize: 24 }} />}
                                        </Box>
                                    </Tooltip>
                                } */}
                {isDrawing &&
                    <Tooltip title={'Отмена'} placement='right'>
                        <Box sx={{
                            width: window.innerWidth < 768 ? 26 : 30,
                            height: window.innerWidth < 768 ? 26 : 30,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            color: 'rgb(255, 94, 0)',
                            transition: 'transform 0.3s ease-in-out',
                            '&:hover': {
                                transform: 'scale(1.1)',
                            }

                        }}
                            onClick={(e) => {
                                e.stopPropagation();
                                if (polygonRef.current) {
                                    map.removeLayer(polygonRef.current)
                                    polygonRef.current = null
                                }
                                drawingRef.current.disable()

                                setVerified(false)
                                setPolygon(null)
                                setIsDrawing(false)
                            }}

                        >
                            <CloseOutlinedIcon sx={{ fontSize: 24 }} />
                        </Box>
                    </Tooltip>
                }
            </Box>
            {(isDrawing || polygon) &&
                <Box
                    sx={{
                        // zIndex: 1202,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        // gap: '5px',
                        pointerEvents: 'auto',
                        backgroundColor: polygon ? (verified ? 'var(--color-blue)' : 'rgb(158, 0, 0)') : 'rgb(40, 40, 40)',
                        color: 'white',
                        borderRadius: '5px',
                        height: window.innerWidth < 768 ? 26 : 30,
                        width: 'auto',
                        opacity: 0.8,
                        padding: '0px 10px',
                        cursor: polygon ? 'pointer' : 'auto',
                        transition: 'transform 0.3s ease-in-out',
                        '&:hover': {
                            transform: polygon ? 'scale(1.05)' : '',
                        }

                    }}

                    onClick={(e) => {
                        if (polygon) {
                            console.log(polygonRef.current)
                            let transformersIds = new Set()
                            let pillarsIds = new Set()
                            let zvzIds = new Set()
                            let opnIds = new Set()
                            let rlndIds = new Set()
                            let runnIds = new Set()
                            let fiders = []
                            
                            map.eachLayer(layer => {
                                if (layer.options.type) {
                                    if (layer.options.type?.includes('transformers') && layer.options.spec && isPointInPolygonRayCasting(layer.getLatLng(), polygonRef.current)) {
                                        transformersIds.add(layer.options.data)
                                    }
                                    if (layer.options.type?.includes('pillar') && isPointInPolygonRayCasting(layer.getLatLng(), polygonRef.current)) {
                                        pillarsIds.add(layer.options.data)
                                    }
                                    if (layer.options.type?.includes('zvz') && isPointInPolygonRayCasting(layer.getLatLng(), polygonRef.current)) {
                                        zvzIds.add(layer.options.data)
                                    }
                                    if (layer.options.type?.includes('opn') && isPointInPolygonRayCasting(layer.getLatLng(), polygonRef.current)) {
                                        opnIds.add(layer.options.data)
                                    }
                                    if (layer.options.type?.includes('rlnd') && isPointInPolygonRayCasting(layer.getLatLng(), polygonRef.current)) {
                                        rlndIds.add(layer.options.data)
                                    }
                                    if (layer.options.type?.includes('runn') && layer.options.spec && isPointInPolygonRayCasting(layer.getLatLng(), polygonRef.current)) {
                                        runnIds.add(layer.options.data)
                                    }
                                    if (layer.options.type?.includes('fider')) {
                                        const segments = []
                                        const posisionsInPolygon = layer.options.positions?.map((pos, i) => (isPointInPolygonRayCasting(new L.latLng(pos[0], pos[1]), polygonRef.current)) ? true : false)
                                        console.log(posisionsInPolygon)
                                        if (posisionsInPolygon.length > 0) {
                                            for (let index = 0; index < posisionsInPolygon.length - 1; index++) {
                                                if (posisionsInPolygon[index] && posisionsInPolygon[index + 1]) segments.push(index)
                                                
                                            }
                                        }
                                        if (segments.length > 0) 
                                            fiders.push({'id': layer.options.data, 'segments': segments})
                                        console.log(layer.options)

                                        // fiderIds.add(layer.options.data)
                                    }

                                    if (layer.options.type === 'cluster') {
                                        layer.getLayers().map(l => {
                                            if (l.options.type?.includes('transformers') && l.options.spec && isPointInPolygonRayCasting(l.getLatLng(), polygonRef.current)) {
                                                transformersIds.add(l.options.data)
                                            }
                                            if (l.options.type?.includes('pillar') && isPointInPolygonRayCasting(l.getLatLng(), polygonRef.current)) {
                                                pillarsIds.add(l.options.data)
                                            }
                                            if (l.options.type?.includes('zvz') && isPointInPolygonRayCasting(l.getLatLng(), polygonRef.current)) {
                                                zvzIds.add(l.options.data)
                                            }
                                            if (l.options.type?.includes('opn') && isPointInPolygonRayCasting(l.getLatLng(), polygonRef.current)) {
                                                opnIds.add(l.options.data)
                                            }
                                            if (l.options.type?.includes('rlnd') && isPointInPolygonRayCasting(l.getLatLng(), polygonRef.current)) {
                                                rlndIds.add(l.options.data)
                                            }
                                            if (l.options.type?.includes('runn') && l.options.spec && isPointInPolygonRayCasting(l.getLatLng(), polygonRef.current)) {
                                                runnIds.add(l.options.data)
                                            }
                                        })
                                    }

                                }


                            })
                            map.removeLayer(polygonRef.current)
                            polygonRef.current = null
                            drawingRef.current.disable()
                            setIsDrawing(false)
                            setVerified(false)
                            setPolygon(null)

                            dispatch(setModal({
                                modalType: 'execution',
                                modalProps: {
                                    ids: { 
                                        transformersIds: [...transformersIds],
                                        pillarsIds: [...pillarsIds], 
                                        zvzIds: [...zvzIds], 
                                        opnIds: [...opnIds], 
                                        rlndIds: [...rlndIds], 
                                        runnIds: [...runnIds],
                                        fiderIds: [...fiders] },
                                    mode: verified,
                                    // mounted: mountedRef.current
                                }
                            }))
                        }
                    }}

                >

                    <Typography variant="body2" sx={{ fontSize: '0.8rem', fontWeight: 'bold' }}>
                        {polygon ? (verified ? 'Подтвердить выполнение' : 'Отменить выполнение') : 'Нарисуйте участок выполнения'}
                    </Typography>

                </Box>}
        </Box>
        , document.getElementById(window.innerWidth < 768 ? "map-controls-left-bottom-first-row-left" : "map-controls-left-bottom")
    )





};

export default ExecutionControl;